/*
 * 配置文件
 * #####################################################################
 * # 注意：本配置文件需要提交到发布服务器上
 * # 保持变量的赋值为空值，除非有新变量的产生，请不要提交到git上去
 * # 可以使用config.development.js文件替代
 * #####################################################################
 * Copyright (c) 2018. supOS
 */

import configDevelopment from './config.development';
import configProduction from './config.production';

export default (process.env.NODE_ENV === 'production' ? configProduction : configDevelopment);
